// The "rotate questions each attempt" switch only makes sense for Practice tests, and its pool is built when the
// test is published, so it can only be changed while the test is a draft.
export const canRotateQuestions = (testType, isDraft) =>
  Boolean(isDraft) && String(testType?.name || "").trim().toLowerCase() === "practice";
